import React, { useState, useEffect } from "react";
import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";

import email from "../../../assets/images/landing/foto_email.png";
import wasap from "../../../assets/images/landing/foto_whatsapp.png";

const NotificationBox = ({ icon, title, message, delay, position }) => {
  const [show, setShow] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  useEffect(() => {
    const timer = setTimeout(() => setShow(true), delay);
    return () => clearTimeout(timer);
  }, [delay]);

  // No renderizar en mobile
  if (isMobile) {
    return null;
  }

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        backgroundColor: "rgba(255, 255, 255, 0.9)",
        borderRadius: "12px",
        padding: "8px 12px",
        boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
        position: "absolute",
        ...position,
        opacity: show ? 1 : 0,
        transform: show ? "translateY(0)" : "translateY(100px)",
        transition: "opacity 0.8s ease-out, transform 0.8s ease-out",
        mr: 1,
        height: "60px",
        maxWidth: "280px", // Limitar ancho para que no se estiren
      }}
    >
      <img
        src={icon}
        alt={title}
        style={{
          width: "40px",
          height: "40px",
          marginRight: "10px",
          marginTop: "5px",
        }}
      />
      <Box sx={{ flex: 1 }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography
            variant="subtitle2"
            sx={{
              fontFamily: "Calibri, sans-serif",
              fontSize: "16px",
              fontWeight: "bold",
              color: "#111111",
              lineHeight: 1.2,
            }}
          >
            {title}
          </Typography>
          <Typography
            variant="caption"
            sx={{
              fontFamily: "Calibri, sans-serif",
              fontSize: "14px",
              color: "#7F7F7F",
            }}
          >
            Ahora
          </Typography>
        </Box>
        <Typography
          variant="body2"
          sx={{
            fontFamily: "Calibri, sans-serif",
            fontSize: "14px",
            color: "#111111",
            lineHeight: 1.1,
          }}
        >
          {message}
        </Typography>
      </Box>
    </Box>
  );
};

const AnimatedNotifications = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  // No renderizar nada en mobile
  if (isMobile) {
    return null;
  }

  return (
    <Box
      sx={{
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        pointerEvents: "none",
      }}
    >
      {/* Notificación 1 - WhatsApp Nueva reserva (superior izquierda) */}
      <NotificationBox
        icon={wasap}
        title="Nueva reserva"
        message="Hola 👋, Has recibido una nueva reserva de cita desde tu perfil online."
        delay={500}
        position={{ 
          top: "40%", 
          right: "15%"
        }}
      />
      
      {/* Notificación 2 - Email Depósito (centro derecha) */}
      <NotificationBox
        icon={email}
        title="Depósito Clinifica"
        message="Depositamos $175.600 a tu cuenta por los pagos de la semana pasada."
        delay={1000}
        position={{ 
          top: "75%", 
          right: "-10%"
        }}
      />
      
      {/* Notificación 3 - WhatsApp Evaluación (inferior izquierda) */}
      <NotificationBox
        icon={wasap}
        title="Nueva evaluación"
        message="Han evaluado tus servicios. Revisa tu perfil online."
        delay={1500}
        position={{ 
          top: "95%", 
          right: "25%"
        }}
      />
    </Box>
  );
};

export default AnimatedNotifications;
